<template>
  <div>
    <wc-section-title title='Tasks'></wc-section-title>
    <router-view
      :loading='isLoading'
      :tasks='tasks'
      :profiles='profiles'
      @update='update'
      @create='create'
      @deleteTask='deleteTask'
    ></router-view>
  </div>
</template>

<script>
import staffingAPI from '@/modules/staffing/api/staffing'
import tasksAPI from '@/modules/tasks/api/tasks'
import miscServices from '@/services/misc'
import _ from 'lodash'

export default {
  name: 'tasks-base',
  data: () => ({
    isLoading: true,
    tasks: [],
    profiles: []
  }),
  computed: {
    menu () {
      return [
        {
          title: 'Tasks Dashboard',
          icon: this.$icons.tasks.icon,
          route: { name: 'TasksDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Tasks Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      let tasks = await tasksAPI.getTasks()
      this.tasks = _.orderBy(tasks, 'due_date')
      let staff = await staffingAPI.getProfiles()
      this.profiles = _.orderBy(staff.filter(s => s.is_active === true), 'name_display')
      this.isLoading = false
    },
    async update (task) {
      this.isLoading = true
      let tmp = await tasksAPI.updateTask(task)
      miscServices.replaceObject(this.tasks, tmp)
      this.isLoading = false
    },
    async create (task) {
      this.isLoading = true
      let tmp = await tasksAPI.createTask(task)
      this.tasks.push(tmp)
      this.isLoading = false
    },
    async deleteTask (task) {
      this.isLoading = true
      await tasksAPI.deleteTask(task.id)
      miscServices.removeObject(this.tasks, task)
      this.isLoading = false
    }
  }
}
</script>